// extracted by mini-css-extract-plugin
module.exports = {"container":"modal_confirmation_container-module--container--3dQGU","overlay":"modal_confirmation_container-module--overlay--1dPfI"};